export const baseUrl =
  process.env.NODE_ENV === "production"
    ? "https://notoputrooffice.com/api"
    : "http://localhost:5001/api";
